<template>
  <div class="main">
    <a-form
      id="formLogin"
      class="user-layout-login"
      ref="formLogin"
      :form="form"
      @submit="handleSubmit"
    >
        <div class="app-name">开放平台</div>
      <a-tabs
        :activeKey="customActiveKey"
        :tabBarStyle="{ textAlign: 'center', borderBottom: 'unset' }"
        @change="handleTabClick"
      >
        <a-tab-pane key="tab1" tab="账号密码登录">
          <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" message="账户或密码错误" />
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入账号"
              v-decorator="[
                'username',
                {rules: [{ required: true, message: '请输入帐户名' }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
              ]"
            >
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input-password
              size="large"
              placeholder="请输入密码"
              v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
            >
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input-password>
          </a-form-item>
        </a-tab-pane>
      </a-tabs>

      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
        >确定</a-button>
      </a-form-item>
    </a-form>

  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import axios from './../api'
export default {
  components: {},
  data () {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false
      }
    }
  },
  created () {

  },
  methods: {
    // handler
    handleUsernameOrEmail (rule, value, callback) {
      const { state } = this
      const regex = /^[a-zA-Z0-9_-]$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick (key) {
      this.customActiveKey = key
    },
    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      state.loginBtn = true

      const validateFieldsKey = ['username', 'password']
      // const v = {
      //   'id': 1,
      //   'username': '18305239882',
      //   'user_id': null,
      //   'role_ids': '6,12,15,32',
      //   'department': null
      // }
      // this.$store.commit('setLoginInfo', {
      //   userData: v,
      //   isLogin: true
      // })
      // localStorage.setItem('loginInfo', JSON.stringify(v))
      // setTimeout(() => {
      //   this.$router.push('/open/passIndex')
      // }, 0)

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = { ...values }
          axios.post('/api/open/login', {
            username: loginParams.username,
            password: loginParams.password
          }).then(v => v.data).then(v => {
            if (v.code === 0) {
              message.success('登录成功')
              this.$store.commit('setLoginInfo', {
                userData: v.data,
                isLogin: true
              })
              localStorage.setItem('loginInfo', JSON.stringify(v.data))
              setTimeout(() => {
                this.$router.push('/open/passIndex')
              }, 0)
            } else {
              if(v.message === '账户已过期') {
                message.error('账户已过期')
              } else {
                message.error('登录失败')
              }
            }
            state.loginBtn = false
          })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
    height: 100%;
    background: #f0f2f5 url(../assets/background.svg) no-repeat 50%;
}
.app-name {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.user-layout-login {
        padding-top: 200px;
    min-width: 260px;
    width: 368px;
    margin: 0 auto;
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
